import { Injectable } from "@angular/core";

@Injectable()
export class EncApiList {
    public encApi = ["b2c/quotations", "idp/cns/consumerleads"];
}



// WEBPACK FOOTER //
// ./src/app/core/encryption/enc_api_list.ts